import { Flex, Text } from "@amzn/storm-ui";
import React from "react";
import styled from "styled-components";

import { UnifiedSearchSortDropdown } from "./UnifiedSearchSortDropdown";

const StyledInfoPanel = styled(Flex)`
    padding: ${({ theme }) => theme.spacing.xsmall.default};
    align-items: center;
`;

export const InfoPanel: React.FunctionComponent<{
    insightCount: number;
    showSearchSortDropdown: boolean;
}> = ({ insightCount, showSearchSortDropdown }) => {
    return (
        <StyledInfoPanel justifyContent="space-between">
            <Text>
                <strong>{insightCount} total</strong>
            </Text>
            <UnifiedSearchSortDropdown />
        </StyledInfoPanel>
    );
};
